import { handleResponseOld, makeGet } from './helpers';

type fetchCategoryRelatedSearchesByCatIDParams = {
    authToken: string;
    categoryId: string;
    deployment: string;
};

type fetchCategoryRelatedSearchesByCatIDResponse = {
    error: boolean;
    payload: [
        {
            displayName: string;
            imageUrl: string;
            relatedCategoryId: number;
            url: string;
        }
    ];
};

/**
 * Fetches related searches from categorization.relatedsearches table, based on current category
 * @function fetchSuggestionsBySearchTerm
 * @category CATEGORY API
 * @param {fetchCategoryRelatedSearchesByCatIDParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/category-api/ /getrelatedsearchestiles?categoryId={}
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/qdhsknmtx7/resources/jvba0j/methods/GET
 */
export const fetchCategoryRelatedSearchesByCatID = ({
    authToken,
    categoryId,
    deployment,
}: fetchCategoryRelatedSearchesByCatIDParams) =>
    new Promise<fetchCategoryRelatedSearchesByCatIDResponse>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<CATEGORY-API>/getrelatedsearchestiles' });
        request.query({ categoryId: parseInt(categoryId) });
        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });
